import request from "@/utils/request";

// 直播班级 创建
export function createLiveClass(data) {
  return request({
    url: "/inner-crm-hologres/pc/ai-data/createLiveClass",
    method: "post",
    data: data,
  });
}
// 直播班级 删除
export function deleteLiveClass(data) {
  return request({
    url: "/inner-crm-hologres/pc/ai-data/deleteLiveClass",
    method: "post",
    data: data,
  });
}
// 直播班级 列表
export function listLiveClass(params) {
  return request({
    url: "/inner-crm-hologres/pc/ai-data/listLiveClass",
    method: "get",
    params: params,
  });
}
// 关联课程列表
export function listLivePreset(params) {
  return request({
    url: "/inner-crm-hologres/pc/ai-data/listLivePreset",
    method: "get",
    params: params,
  });
}
// 直播班级 更新
export function updateLiveClass(data) {
  return request({
    url: "/inner-crm-hologres/pc/ai-data/updateLiveClass",
    method: "post",
    data: data,
  });
}
